import { Cookies } from "react-cookie";

import {
  LANGUAGE_PATH,
  REGIONAL_MICROSITE_PREFIX_PATH,
} from "hooks/useIsNewDesign";
import { STORE_INFO_MAPPING } from "./mapping";
import { CountryCode, Language, StoreId } from "@ubnt/store.core/lib/types";
import { DEFAULT_LANGUAGE, GLOBAL_SITE_CONFIG } from "./constants";

const cookies = new Cookies();

/**
 * Util to get language for given country code
 */
export const getDefaultLanguageByRegion = (
  countryCode: CountryCode,
): Language => {
  const storeId = STORE_INFO_MAPPING.find((store) =>
    store.countries.includes(countryCode),
  )?.id;

  if (!storeId) {
    return DEFAULT_LANGUAGE;
  }

  return (
    GLOBAL_SITE_CONFIG.ui.regions[storeId].defaultLanguage ?? DEFAULT_LANGUAGE
  );
};

/**
 * Eval country code
 */
export const evalCountryCode = (
  countryCode: string | undefined,
): CountryCode | undefined => {
  return Object.values(CountryCode).find(
    (cc) => cc.toUpperCase() === countryCode?.toUpperCase(),
  );
};

/**
 * Parse language code
 */
export const evalLanguageCode = (
  languageCode: string | undefined,
): Language | undefined => {
  return Object.values(Language).find(
    (lc) => lc.toUpperCase() === languageCode?.toUpperCase(),
  );
};

/**
 * Parse StoreId
 */
export const evalStoreId = (
  storeId: string | undefined,
): StoreId | undefined => {
  return Object.values(StoreId).find(
    (gsi) => gsi.toUpperCase() === storeId?.toUpperCase(),
  );
};

export const isValidStoreLanguage = (storeId: StoreId, language: Language) => {
  const storeLanguages = GLOBAL_SITE_CONFIG.ui.regions[storeId].languages;
  return storeLanguages.includes(language);
};

/**
 * This returns all page base paths for a given page path
 */
export const getPageBasePaths = (pagePath) => {
  return [
    pagePath,
    `${REGIONAL_MICROSITE_PREFIX_PATH}${pagePath}`,
    `${REGIONAL_MICROSITE_PREFIX_PATH}${LANGUAGE_PATH}${pagePath}`,
    // Trim trailing slash, but only if it's not the only character
  ].map((path) => (path === "/" ? path : path.replace(/\/$/, "")));
};

export const saveCookie = (codeKey, language) => {
  const today = new Date();
  cookies.set(codeKey, language, {
    path: "/",
    domain: __CONFIG__.isProd ? ".ui.com" : "",
    secure: __CONFIG__.isProd || __CONFIG__.isQA,
    sameSite: "lax",
    expires: new Date(today.setFullYear(today.getFullYear() + 1)), // add one year to current date
  });
};
